<template></template>

<script>
import { ref } from "vue";
import Map from "@/utils/Map.js";
import { toast } from "vue3-toastify";
import Timer from "@/utils/Timer.js";

export default {
  props: {
    config: Object,
  },
  setup() {
    return {
      clock: ref(0),
      // ---
      dock_pin: ref(false),
      dock_alt_pin: ref(false),
      // ---
      flight_maps_details: ref({}),
      firstShow: ref(false),
    };
  },
  mounted() {
    this.firstShow = this.$route.name !== "Site_FlightCurrent_device";

    /** PLACEMENT */
    this.placementDock();
    this.placementAltDock();

    /** UPDATE */
    Timer.addRequest(`updateDock_${this.config.dock.id}`, {
      timer: async () => {
        this.updateDock();
        this.updateAltDock();
        this.clock++;
      },
    });
  },

  unmounted() {
    if (this.$root.isPopup) return;

    Timer.closeRequest(`updateDock_${this.config.dock.id}`);
    Map.getViewer().entities.remove(this.dock_pin);
    Map.getViewer().entities.remove(this.dock_alt_pin);
  },

  methods: {
    placementDock() {
      if (Map.getViewer()?.entities == undefined) {
        setTimeout(() => {
          this.placementDock();
        }, 2000);
        return;
      }

      this.dock_pin = Map.getViewer().entities.add({
        name: `#${this.config.dock.id} - ${this.config.dock.name}`,
        position: Cesium.Cartesian3.fromDegrees(0, 0, -5000),
        ellipse: {
          semiMinorAxis: 1,
          semiMajorAxis: 1,
          material: new Cesium.ImageMaterialProperty({
            image: window.location.origin + "/assets/images/ground_H.jpg",
          }),
          heightReference: Cesium.HeightReference.NONE,
        },

        label: {
          text: `#${this.config.dock.id} - ${this.config.dock.name}`,
          font: "14px Inter, sans-serif",
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          showBackground: true,
          backgroundColor: Cesium.Color.BLACK,
          outlineWidth: 5,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          eyeOffset: new Cesium.Cartesian3(0, 3, 0),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            5000
          ),
          //disableDepthTestDistance: Number.POSITIVE_INFINITY,
          // clampToGround: true,
          // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
      });
      this.dock_pin.show = false;
    },

    placementAltDock() {
      if(Map.getViewer()?.entities == undefined) {
        setTimeout(() => {
          this.placementAltDock();
        }, 2000);
        return;
      }

      this.dock_alt_pin = Map.getViewer().entities.add({
        name: `#${this.config.dock.id} - ${this.config.dock.name} (Point d'attérisage alternatif)`,
        position: Cesium.Cartesian3.fromDegrees(0, 0, 0),
        ellipse: {
          semiMinorAxis: 1,
          semiMajorAxis: 1,
          material: new Cesium.ImageMaterialProperty({
            image: window.location.origin + "/assets/images/ground_alt.jpg",
          }),
          heightReference: Cesium.HeightReference.NONE,
        },
        label: {
          text: `Point d'attérisage alternatif\n#${this.config.dock.id} - ${this.config.dock.name}`,
          font: "14px Inter, sans-serif",
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          showBackground: true,
          backgroundColor: Cesium.Color.BLACK,
          outlineWidth: 5,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          eyeOffset: new Cesium.Cartesian3(0, 3, 0),
          //disableDepthTestDistance: Number.POSITIVE_INFINITY,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            5000
          ),
          clampToGround: true,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          zIndex: 990,
        },
      });

      this.dock_alt_pin.show = false;
    },

    // ---

    updateDock() {
      if (
        this.clock % 15 == 0 ||
        (this.dock_pin != false && this.dock_pin?.show == false)
      ) {
        if (
          this.dock_pin !== false &&
          this.config?.dock?.status?.latitude !== undefined &&
          this.config?.dock?.status?.longitude !== undefined &&
          this.config?.dock?.status?.height !== undefined &&
          this.config?.dock?.status?.latitude !== 0 &&
          this.config?.dock?.status?.longitude !== 0
        ) {
          this.dock_pin.show = true;
          this.dock_pin.position = Cesium.Cartesian3.fromDegrees(
            this.config.dock.status.longitude,
            this.config.dock.status.latitude,
            this.config.dock.status.height
          );

          this.dock_pin.extrudedHeight = this.config.dock.status.height - 0.5;

          if (this.firstShow == false) {
            this.firstShow = true;
            this.ShowTheDock();
          }

          if (this.$route.params?.flg_id == undefined) {
            return;
          }
          if (this.flight_maps_details.safe_height !== undefined) {
            Map.getViewer().entities.remove(
              this.flight_maps_details.safe_height
            );
          }

          if (this.config?.flight?.info?.mis_geom == undefined) {
            return;
          }

          let pointDepart = this.config?.flight?.info?.mis_geom.coordinates[0];
          let pointArriver =
            this.config?.flight?.info?.mis_geom.coordinates[
              this.config?.flight?.info?.mis_geom.coordinates.length - 1
            ];

          let safe_height =
            this.config?.flight?.info?.flg_safeheight != undefined
              ? this.config?.flight?.info?.flg_safeheight
              : 50;

          if (pointDepart == undefined || pointArriver == undefined) {
            return;
          }

          this.flight_maps_details.safe_height = Map.getViewer().entities.add({
            name: `#${this.config.dock.id} - ${this.config.dock.name} (safe_height)`,
            position: Cesium.Cartesian3.fromDegrees(
              this.config.dock.status.longitude,
              this.config.dock.status.latitude,
              this.config.dock.status.height + safe_height
            ),
            zIndex: 999,
            ellipse: {
              semiMinorAxis: 1,
              semiMajorAxis: 1,
              material: Cesium.Color.fromBytes(150, 150, 150).withAlpha(1),
            },
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                pointDepart[0],
                pointDepart[1],
                pointDepart[2],
                // ---
                this.config.dock.status.longitude,
                this.config.dock.status.latitude,
                this.config.dock.status.height +
                  this.config?.flight?.info?.flg_safeheight,
                // ---
                pointArriver[0],
                pointArriver[1],
                pointArriver[2],
                // ---
                this.config.dock.status.longitude,
                this.config.dock.status.latitude,
                this.config.dock.status.height +
                  this.config?.flight?.info?.flg_safeheight,
                // ---
                this.config.dock.status.longitude,
                this.config.dock.status.latitude,
                0,
              ]),
              width: 0.5,
              material: Cesium.Color.fromBytes(150, 150, 150).withAlpha(1),
            },
          });
        } else if (this.dock_pin !== false) {
          this.dock_pin.show = false;
          // console.log(this.dock_pin.position);
        }
      }
    },

    updateAltDock() {
      if (
        this.clock % 60 == 0 ||
        (this.dock_alt_pin !== false && this.dock_alt_pin?.show == false)
      ) {
        if (
          this.dock_alt_pin !== false &&
          this.config?.drone?.status?.alternate_land_point?.latitude !==
            undefined &&
          this.config?.drone?.status?.alternate_land_point?.longitude !==
            undefined &&
          this.config?.drone?.status?.alternate_land_point?.height !==
            undefined &&
          this.config?.drone?.status?.alternate_land_point?.latitude !== 0 &&
          this.config?.drone?.status?.alternate_land_point?.longitude !== 0
        ) {
          this.dock_alt_pin.show = true;
          this.dock_alt_pin.position = Cesium.Cartesian3.fromDegrees(
            this.config.dock.status.alternate_land_point.longitude,
            this.config.dock.status.alternate_land_point.latitude,
            this.config.dock.status.alternate_land_point.height
          );

          this.dock_alt_pin.description = `<ul>
            <li>Longitude : ${this.config.dock.status.alternate_land_point.longitude}</li>
            <li>Latitude : ${this.config.dock.status.alternate_land_point.latitude}</li>
            <li>Hauteur : ${this.config.dock.status.alternate_land_point.height}</li>
          </ul>`;
        } else if (this.dock_alt_pin !== false) {
          this.dock_alt_pin.show = false;
        }
      }
    },

    ShowTheDock() {
      if (this.dock_pin !== false && this.dock_pin.show) {
        Map.getViewer().camera.lookAt(
          this.dock_pin.position.getValue(Date.now()),
          new Cesium.Cartesian3(0, 0, 500)
        );
        Map.getViewer().camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      } else {
        toast.error("Position du dock inconnu", this.$root.toastConfig);
      }
    },
  },

  watch: {
    config: {
      handler: function (val, oldVal) {
        if (this.config.dock.methods !== undefined) {
          this.config.dock.methods.ShowTheDock = this.ShowTheDock;
        }
      },
      deep: true,
    },
  },
};
</script>
